import { CalendarEventFormFields } from '@griply/types';

// The one gate both platforms submit through. A backwards span is the shape the providers
// reject outright, so it is caught here rather than at the callable — and an all-day event
// is inclusive (it may start and end on the same day) while a timed one may not be empty.
export const isCalendarEventFormValid = (
  fields: CalendarEventFormFields,
): boolean => {
  if (!fields.title.trim() || !fields.calendar) {
    return false;
  }

  if (fields.allDay) {
    return fields.endDate >= fields.startDate;
  }

  if (fields.startTime === null || fields.endTime === null) {
    return false;
  }

  return (
    fields.endDate.getTime() + fields.endTime >
    fields.startDate.getTime() + fields.startTime
  );
};
